export const getClientId = () => {
  if (typeof window === "undefined") return null;

  const key = "client_id_v1";
  let id = localStorage.getItem(key);

  if (!id) {
    id =
      (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(key, id);
  }
  return id;
};
